
    import { defineComponent } from 'vue'
    import { iRule } from '../../MeasureDefinition'
    import Column from 'primevue/column'
    import DataTable from 'primevue/datatable'
    import Dialog from 'primevue/dialog'
    import previewDialogDescriptor from './MeasureDefinitionPreviewDialogDescriptor.json'

    export default defineComponent({
        name: 'measure-definition-preview-dialog',
        components: { Column, DataTable, Dialog },
        props: {
            currentRule: {
                type: Object,
                required: true
            },
            placeholders: {
                type: Array,
                required: true
            },
            columns: { type: Array },
            propRows: { type: Array }
        },
        emits: ['close', 'loadPreview'],
        watch: {
            propRows() {
                this.loadRows()
            },
            currentRule() {
                this.loadRule()
            }
        },
        data() {
            return {
                previewDialogDescriptor,
                rule: {} as iRule,
                rows: [] as any[]
            }
        },
        async created() {
            this.loadRule()
            this.loadRows()
        },
        methods: {
            loadRule() {
                this.rule = this.currentRule as iRule
            },
            loadPreview() {
                this.$emit('loadPreview')
            },
            loadRows() {
                this.rows = this.propRows as any[]
            },
            closeTemplate() {
                this.$emit('close')
            }
        }
    })
